import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider, { createSliderWithTooltip } from 'rc-slider';

const SliderTooltip = createSliderWithTooltip(Slider);

export const calculateWin = (stake, odds) => (stake * (odds - 1));

class OddsSlider extends Component {
  static propTypes = {
    stakeAmount: PropTypes.number.isRequired,
    odds: PropTypes.number.isRequired,
  };

  state = {
    odds: this.props.odds,
    winAmount: calculateWin(this.props.stakeAmount, this.props.odds)
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.stakeAmount !== this.props.stakeAmount) {
      this.setState({
        winAmount: calculateWin(nextProps.stakeAmount, this.state.odds)
      });
    }
  }

  onSliderChange = value => {
    const odds = getRealOdds(value);
    this.props.handleOddsChange(odds);
    this.setState({
      odds: odds,
      winAmount: calculateWin(this.props.stakeAmount, odds)
    });
  };

  render() {
    return (
      <div id="odds-slider">
        <label className="title">Set Your Odds</label>
        <div className="sub-label">Define the odds multiplier of your stake</div>
        {/* <Input type="number" inverted value={2} /> */}

        <div className="slider-container">
          {/* value={this.state.odds} */}
          <SliderTooltip
            min={1}
            max={20}
            defaultValue={getInternalOdds(this.props.odds)}
            onChange={this.onSliderChange}
            tipFormatter={value => getRealOdds(value)}
          />

          <div className="box-holder">
            <div className="sub-label">You Lose</div>
            <div className="box lose">{this.props.stakeAmount}</div>
          </div>

          <div className="box-holder right">
            <div className="sub-label">You Win</div>
            <div className="box win">{this.state.winAmount.toFixed()}</div>
          </div>
        </div>
      </div>
    );
  }
}

// LoL
const getInternalOdds = realOdds => {
  if (realOdds < 2) {
    let decimal = realOdds - Math.floor(realOdds);
    return decimal.toFixed(1) * 10;
  }
  if (realOdds >= 2) {
    return realOdds + 8;
  }
};

const getRealOdds = value => {
  if (value < 10) {
    let decimal = value / 10;
    return 1 + decimal;
  }
  if (value >= 10) {
    return value - 8;
  }
  return value;
};

export default OddsSlider;



// WEBPACK FOOTER //
// ./src/App/CreateStake/OddsSlider.js